import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import DashboardLayout from '@/components/DashboardLayout'
import EventForm, { type EventFormPurchasableItem } from '@/components/EventForm'
import type { Event } from '@/types'

type EditEventProps = {
  event: Event
  dress_codes: string[]
  causes: string[]
  purchasable_items: EventFormPurchasableItem[]
  stripe_payment_ready: boolean
  landing_url: string | null
}

export default function DashboardEventsEdit({
  event,
  dress_codes,
  causes,
  purchasable_items,
  stripe_payment_ready,
  landing_url,
}: EditEventProps) {
  return (
    <>
      <Head title={`Edit ${event.page_kind === 'fundraiser' ? 'Fundraising Campaign' : 'Event Campaign'}`} />
      <EventForm
        event={event}
        dressCodes={dress_codes}
        causes={causes}
        purchasableItems={purchasable_items}
        stripePaymentReady={stripe_payment_ready}
        landingUrl={landing_url}
      />
    </>
  )
}

DashboardEventsEdit.layout = (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>
